import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Modal
} 
from '../../../noser-hris-component';

class FileUpload extends Component {
    constructor(props) {
        super(props)
        this.ref = React.createRef();
        this.state = {
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            
            clientId    :   '',
            periodId    :   '',
            fileName    : null,
            paycardtypeId:"",
        }
    }
    componentDidMount(){
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.props.onRefModal(this)
    }
    componentWillUnmount() {
        this.props.onRefModal(undefined)
    }
    initialize=(e)=>{
        console.log(e)
        this.setState({
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            name        :   '',
            disableBtn  :   false,

            clientId    :   e.clientId,
            periodId    :   e.periodId,
            fileName    :   null,
            paycardtypeId:  e.paycardtypeId,
        })
    }
    handleSubmit = async() =>{
        
        if(this.state.fileName==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select file to upload.",
                fade        :   true,
                disableBtn  :   false
            })
            return 
        }
        this.setState({isloading:true})
        const formData = new FormData();
        formData.append('IpAddress', "0.0.0.0");
        formData.append('UserId', this.state.userinfo.userId);
        formData.append('ClientId', this.state.clientId);
        formData.append('PayPeriodId', this.state.periodId);
        formData.append('PaycardTypeId', this.state.paycardtypeId);
        formData.append('File', this.state.fileName);

        await axios
            .post(
                AppConfiguration.Setting().noserapiendpoint + "Accounting/UploadPayrollFie",  formData, {headers: {'Content-Type': 'multipart/form-data'}}
            )
            .then(res => {
                const data = res.data;
                if(data.status=="1")
                {
                    this.setState({
                        isloading   :   false,
                        alerttype   :   "Success!",
                        isshow      :   true,
                        color       :   "success",
                        message     :   data.message,
                        fade        :   true
                    });
                }
                else{
                    this.setState({
                        isloading   :   false,
                        alerttype   :   "Error!",
                        isshow      :   true,
                        color       :   "danger",
                        message     :   data.message,
                        fade        :   true,
                    });
                }
            })
            .catch(error=>{
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade        :   true,
                })
            })
    }
    handleModalClose = () => {
        this.props.onHide();            
    }
    handleFileChange = (event) => {
        this.setState({ fileName: event.target.files[0] });
    };
    render() {
    return(
        
            <Modal
                {...this.props}
                return
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="card-header">
                    <Modal.Title id="contained-modal-title-vcenter">
                        UPLOAD RETURN FILE
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                            <div className={this.state.color}></div> 
                            {this.state.message}
                        </Alert>
                        <Form.Group>
                            <Form.Label>Select File to Upload</Form.Label>
                            <Form.Control 
                                type="file" 
                                accept='.xlsx'
                                onChange={this.handleFileChange}
                            />
                            <Form.Text className="text-muted">
                                Uploading for: <strong>{this.state.selectedUploadRow && this.state.selectedUploadRow.reference}</strong>
                            </Form.Text>
                        </Form.Group>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar >
                        <Button variant="success" className="ml-auto noser-button-mr1" onClick = {() => this.handleSubmit('2')} disabled={this.state.disableBtn}>SUBMIT</Button>
                        <Button variant="danger" className="noser-button-mr15" onClick={this.props.onHide}>Close</Button>
                    </ButtonToolbar>
                </Modal.Footer>
                <NoserLoading show={this.state.isloading} />
        </Modal>
        );
    }
}
export default FileUpload